"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOWELS = exports.CONSONANTS = exports.NO_BONUS = exports.EMPTY_CELL = exports.BONUS_WORD = exports.BONUS_CHARACTER = exports.BLANK = exports.COMMA_LATIN = exports.COMMA_ARABIC = void 0;
exports.COMMA_ARABIC = '،';
exports.COMMA_LATIN = ',';
exports.BLANK = ' ';
exports.BONUS_CHARACTER = 'BONUS_CHARACTER';
exports.BONUS_WORD = 'BONUS_WORD';
exports.EMPTY_CELL = ' ';
exports.NO_BONUS = { characterMultiplier: 1, wordMultiplier: 1 };
exports.CONSONANTS = 'bcçćdfgğhjklłmnńñpqrsşśtvwxzźż'.split('');
exports.VOWELS = 'aąäeęioóöuüyı'.split('');
